export const environment = {
    name: 'Production',
    production: true,
    reCaptchaSiteKey: '6LdDnocgAAAAAOruOo4KNYI7GwwgwfmmMpJNH3Cg',
    ccApiUrl: 'https://api.ciranet.com/api/',
    ccManagementPortalApiUrl: 'https://api.ciranet.com/managementportal/api/',
    userActivityHostApiUrl: 'https://www.ciranet.com/managementportal',
    portalSelectionUrl: 'https://www.ciranet.com/v2',
    ciranetHelpUrl: 'https://www.ciranet.com/v2/managementportal/cirahelp{HELP_ID}{CONTEXT}?portal=mp',
    ccChatButtonScript:
        '<script src="https://www.ciranet.com/CiraChat/Chat/Support-Image-Button.js.aspx?ChatDepartment={0}{1}"></script>',
    defaultThemeColor: 'light-blue',
    defaultCiraMailRefreshRate: 30,
    defaultRounding: 2,
    defaultOpenLinks: 'internal', // or external
    defaultWindowTitle: 'Management Portal',
    enableUserSession: false,
    tinymceBaseUrl: '/v2/managementportal/tinymce',
    homePath: 'https://www.ciranet.com/v2/managementportal/home',
    communityPath: 'https://www.ciranet.com/v2/managementportal/community/{{communityId}}/home',
    propertyPath: 'https://www.ciranet.com/v2/managementportal/property/{{communityId}}/{{accountNo}}/home',
    boardMemberRedirectionUrl: 'https://www.ciranet.com',
    closingPortalUrl: `https://www.ciranet.com/closingportal/`,
    offlineRedirectUrl: 'https://offline.ciranet.com',
    sentryDsnUrl: 'https://a2391b5dc9c2c5d419a3e949dcf60b19@sentry.ciranet.com/3',
    sentryTracesSampleRate: 0.1 // Only sample 10% of traces in production to avoid overloading Sentry
};
